import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { MuiInputDirective } from '@df/legacy/ui/form/mui-input.directive';
import { LoqateEmailValidateDirective } from '@df/module-loqate/email/loqate-email.validator';
import { NgInject } from '@df/ng/ng-inject';
import { TimeoutService } from '@df/ng/timeout.service';
import { LoginFormComponentDef } from '@df/session/login/login-form.component.def';
import { Login } from '@df/session/login/login.interfaces';
import { MatchCheckDirective } from '@df/ui/form/match-check.directive';
import { RadioGroupDirective } from '@df/ui/form/radio/radio.component.def';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsConfig } from '@icms/core/resource/config/icms-config';
import { ICmsConfigResource } from '@icms/core/resource/config/icms-config.resource';
import { CMS_CONFIG_NEWSLETTER, IICmsConfigNewsletterData } from '../../../cms/config/newsletter.cms-config';
import { SocialLoginComponent } from '../../../ui/3rdparty/social-login.component';
import { ActionComponent } from '../../../ui/api/action.component';
import { InputWrapBodyDirective } from '../../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../../ui/form/input-wrap.component';
import { RadioComponent } from '../../../ui/form/radio';
import { ResultComponent } from '../../../ui/resut/result.component';
import { ILoginViewLayoutContent } from '../../view/layout/login-view-layout.component';
@Component({
    selector: 'login-form-retail',
    templateUrl: './login-form-retail.component.html',
    standalone: true,
    imports: [
        ActionComponent,
        FormsModule,
        ICmsClientModule,
        InputWrapComponent,
        InputWrapBodyDirective,
        LoqateEmailValidateDirective,
        MatchCheckDirective,
        MuiInputDirective,
        NgClass,
        RadioComponent,
        RadioGroupDirective,
        ResultComponent,
        RouterLink,
        SocialLoginComponent,
        TranslationModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginFormRetailComponent extends LoginFormComponentDef implements OnInit {
    @Input()
    content: ILoginViewLayoutContent;
    /**
     * By default register form it is not visible
     */
    registerPageIsVisible = false;
    protected newsletterPreselection: string | null = null;
    @NgInject(TimeoutService)
    protected timeoutService: TimeoutService;
    @NgInject(ICmsConfigResource)
    protected cmsConfigResource: ICmsConfigResource;
    override ngOnInit() {
        super.ngOnInit();
        this.cmsConfigResource.loadModelByUrl(CMS_CONFIG_NEWSLETTER).then(() => {
            const config = this.cmsConfigResource.getModelByUrl(CMS_CONFIG_NEWSLETTER) as ICmsConfig<IICmsConfigNewsletterData>;
            const preselection = config?.data?.content?.emailNewsletterPreselection;
            if (preselection === 'all') {
                this.newsletterPreselection = '1';
                ((this.data as Login.IRegisterFormData).newsletter as string | number) = this.newsletterPreselection;
            }
        });
    }
    protected override setCheckResult(checkResult?: Login.IResponseAccountExists) {
        if (this.registerPageIsVisible === checkResult?.exists) {
            this.registerPageIsVisible = !checkResult?.exists;
        }
        super.setCheckResult(checkResult);
    }
    showRegisterForm(status: boolean): void {
        this.registerPageIsVisible = status;
        this.detectChanges();
    }

    get registerData(): Partial<Login.IRegisterFormData> {
        return this.data as Partial<Login.IRegisterFormData>;
    }
}
